module.exports = __webpack_public_path__ + "static/3A841E_3_0-2d50270eddbd65daa05a245b9760c3bd.woff2";